module.exports = "../../static/img/noData.2745350.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/noData.png
// module id = kzP1
// module chunks = 36